import initialState from './../../initialState';

export default (state = initialState.admin, { type, value, response }) => {
  switch (type) {
    case 'LIST_ACESSOS_ADMINISTRACAO_SUCCESS':
      return {
        ...state,
        acessos: {
          ...state.acessos,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_PENDENCIAS_ADMINISTRACAO_SUCCESS':
      return {
        ...state,
        problemas: {
          ...state.problemas,
          fetching: 2,
          result: response,
          errors: []
        }
      };
    case 'ADMIN_LIST_CONTRATANTES_SUCCESS':
      return {
        ...state,
        contratantes: {
          ...state.contratantes,
          fetching: 2,
          result: response,
          errors: []
        }
      };
    case 'ADMIN_STATUS_CONTRATANTES_SUCCESS':
      state.contratantes.result.find(v => v === value.value).status =
        value.status;

      return {
        ...state,
        contratantes: {
          ...state.contratantes,
          fetching: 2,
          errors: []
        }
      };
    case 'ADMIN_LIST_ROLES_CONTRATANTES_SUCCESS':
      return {
        ...state,
        rolesContratantes: {
          ...state.rolesContratantes,
          fetching: 2,
          result: response,
          errors: []
        }
      };
    case 'ADMIN_STATUS_ROLES_CONTRATANTES_SUCCESS':
      state.rolesContratantes.result.find(v => v === value.value).status =
        value.status;

      return {
        ...state,
        rolesContratantes: {
          ...state.rolesContratantes,
          fetching: 2,
          errors: []
        }
      };
    case 'ADMIN_LIST_ROLES_SUCCESS':
      return {
        ...state,
        roles: {
          ...state.roles,
          fetching: 2,
          result: response,
          errors: []
        }
      };
    case 'WEBHOOK_LIST_TYPE_EVENT_USERS_SUCCESS':
      return {
        ...state,
        typeEventUsers: {
          ...state.typeEventUsers,
          fetching: 2,
          result: response,
          errors: []
        }
      };
    case 'WEBHOOK_STATUS_TYPE_EVENT_USERS_SUCCESS':
      state.typeEventUsers.result.find(v => v.id === value.value.id)['status_' + value.type_status] = value.status;

      return {
        ...state,
        typeEventUsers: {
          ...state.typeEventUsers,
          fetching: 2,
          errors: []
        }
      };
    case 'ADMIN_STATUS_ROLES_SUCCESS':
      var role = state.roles.result.find(v => v === value.value);
      if (role) {
        role.status = value.status;
      }

      return {
        ...state,
        roles: {
          ...state.roles,
          fetching: 2,
          errors: []
        }
      };
    case 'LIST_CONTATOS_ADMINISTRACAO_REQUEST':
      return {
        ...state,
        contatos: {
          ...state.contatos,
          fetching: 1
        }
      };
    case 'LIST_CONTATOS_ADMINISTRACAO_SUCCESS':
      return {
        ...state,
        contatos: {
          ...state.contatos,
          fetching: 2,
          result: response.list
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/admin/reducer.js